import angular from 'angular';

import SelectorFechaDirective from './selector-fecha.directive';
import SeparadorMilesDirective from './separador-miles.directive';
import BlurConEnterDirective from './blur-con-enter.directive';



const MODULE_NAME = 'buscador.directivas';

const ngModule=angular.module(MODULE_NAME, []);

ngModule
            .directive('itSelectorFecha', ['fechaConfig', '$timeout','utilFactory',(fechaConfig,$timeout,utilFactory) =>new SelectorFechaDirective(fechaConfig,$timeout,utilFactory)])
            .directive('itSeparadorMiles',() =>new SeparadorMilesDirective)
            .directive('itBlurConEnter',() =>new BlurConEnterDirective);


export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/directivas/index.js